export default __webpack_public_path__ + "static/media/Prison-3D-Model-04.74a250fd.jpg";